/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function BackIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="21" height="20" viewBox="0 1 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_582_13748" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="20">
        <rect x="0.0400391" width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_582_13748)">
        <path d="M6.18427 10.625L10.492 14.9327C10.6159 15.0566 10.6771 15.2017 10.6755 15.3678C10.6739 15.5339 10.6084 15.6816 10.4791 15.8109C10.3499 15.9316 10.2035 15.9941 10.0401 15.9984C9.8766 16.0027 9.73024 15.9402 9.60098 15.8109L4.31733 10.5272C4.23935 10.4493 4.18433 10.367 4.15227 10.2804C4.12021 10.1939 4.10419 10.1004 4.10419 10C4.10419 9.89958 4.12021 9.8061 4.15227 9.71957C4.18433 9.63303 4.23935 9.55076 4.31733 9.47278L9.60098 4.18913C9.71635 4.07374 9.85924 4.01472 10.0296 4.01205C10.2 4.00938 10.3499 4.06841 10.4791 4.18913C10.6084 4.3184 10.6731 4.4669 10.6731 4.63463C10.6731 4.80237 10.6084 4.95087 10.4791 5.08013L6.18427 9.37503H15.665C15.8424 9.37503 15.9909 9.43486 16.1105 9.55451C16.2302 9.67416 16.29 9.82266 16.29 10C16.29 10.1774 16.2302 10.3259 16.1105 10.4455C15.9909 10.5652 15.8424 10.625 15.665 10.625H6.18427Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default BackIcon;
